export const siteConfig = {
  name: "Sandberg Rådgivende Ingeniører ApS",
  logo: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/b158332e-c073-43e3-85ff-627a517abc6a.png",
  tagline: "Rådgivning inden for byggeri.",
  description: "Uvildig rådgivning med fokus på faglig præcision og ordentlighed. Vi bistår bygherrer gennem alle faser af et projekt.",
  heroImage: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/e35e9313-ee33-47bd-98a4-94c0ad7d4a1b.jpg",
  contact: {
    phone: "27 85 40 98",
    email: "hs@sandberg-ri.dk",
    address: "Ulbækvej 24, 8721 Daugård",
    cvr: "42233463"
  },
  navigation: [
    { name: "Forside", href: "/" },
    { name: "Ydelser", href: "/ydelser" },
    { name: "Om os", href: "/om-os" },
    { name: "Referencer", href: "/referencer" },
    { name: "Kontakt", href: "/kontakt" }
  ],
  services: [
    {
      title: "Bygherrerådgivning",
      description: "Rådgivning og styring fra projektidé til aflevering.",
      image: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/16a73f3d-7dd0-48c9-8f6b-ece2267b3889.jpg"
    },
    {
      title: "Projektledelse",
      description: "Koordinering af tid, økonomi og kvalitetssikring.",
      image: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/ab422fab-4e8a-427f-9ae4-c96cc226a693.jpg"
    },
    {
      title: "Teknisk Rådgivning",
      description: "Rådgivning vedrørende konstruktioner og afløbsinstallationer.",
      image: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/2d0968bd-72b3-41a1-8d4a-d73ac87ec7da.jpg"
    },
    {
      title: "Tilsyn",
      description: "Uvildigt tilsyn med udførelse og overholdelse af tekniske krav.",
      image: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/c712c7e5-d92d-4549-b97a-1563eb798094.jpg"
    }
  ],
  references: [
    {
      slug: "bilhus-middelfart",
      title: "Bilhus i Middelfart",
      category: "Erhverv",
      client: "Tegnestuen Mejeriet, Kolding",
      description: "Rådgivning i forbindelse med opførelse af bilhus.",
      fullDescription: "SRI har været underrådgiver på projektet, som ligger ud til den fynske motorvej umiddelbart efter Lillebæltsbroen. Projektet udviklede sig fra en ombygning af en industriejendom i Middelbart til en 3000m² stor bygning ved motorvejen. Det særlige ved projektet er en stor lounge, som er hængt op i taget og dets karakteristiske betonfacader, som ligner en træbeklædning.",
      image: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/d89e70da-5f3d-4041-b47c-512a118d7d14.jpg"
    },
    {
      slug: "grejsdalens-efterskole",
      title: "Grejsdalens Efterskole, om- og tilbygning",
      category: "Institution",
      client: "Grejsdalens Efterskole",
      description: "Omfattende om- og tilbygning af efterskole.",
      fullDescription: "SRI har udarbejdet konstruktions- og brandprojekt i forbindelse med ansøgning om byggetilladelse. Har i forlængelse heraf udarbejdet et udbudsprojekt for udbud i storentreprise, kontraheret og forestået byggeledelsen i udførelsesperioden.\n\nTilbygningen blev taget i brug juni 2018.",
      image: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/3cb9ba8e-cceb-4a2a-9842-646a691d1d85.jpg"
    },
    {
      slug: "vuggestue-gadkjaergaard",
      title: "Vuggestue, Gadkjærgård i Vinding",
      category: "Institution",
      client: "Vejle Kommunale Ejendomme",
      description: "Tilbygning til eksisterende institution Gadkjærgård i Vinding.",
      fullDescription: "Tilbygning til eksisterende institution Gadkjærgård i Vinding med plads til 52 vuggestuebørn fordelt på 4 stuer. SRI har projekteret og ført tilsyn med bærende konstruktioner, afløb, brand og akustik.\n\nBygningen opført i kalksandstensblokke og græstag. Regnvand nedsives på grunden.",
      image: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/e4a91709-c174-484d-9469-a3e78cec104a.jpg"
    },
    {
      slug: "nye-vaerelsesbygninger-raagelund-efterskole",
      title: "Nye værelsesbygninger, Rågelund Efterskole",
      category: "Undervisning & Institution",
      client: "Mejeriet A/S",
      description: "Bygningerne er opført som en let bygninger, hvor de bærende konstruktioner i træ.",
      fullDescription: "SRI har ydet rådgivning vedr. bærende konstruktioner og afløb. Bygningerne er opført som en let bygninger, hvor de bærende konstruktioner i træ.",
      image: "https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/ragelund-efterskole-01.jpg"
    }
  ]
};
